import { render, staticRenderFns } from "./TaskManagelist.vue?vue&type=template&id=56f95ae3&scoped=true&"
import script from "./TaskManagelist.vue?vue&type=script&lang=js&"
export * from "./TaskManagelist.vue?vue&type=script&lang=js&"
import style0 from "./TaskManagelist.vue?vue&type=style&index=0&id=56f95ae3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f95ae3",
  null
  
)

export default component.exports